<template>
	<iframe
		allow="microphone; fullscreen"
		id="ifr"
		ref="iframe"
		:class="{ full: fullscreen }"
		:height="height"
		:src="src"
		@load="onIframeLoad"
    allowfullscreen
		frameborder="0"
	/>
</template>

<script>
export default {
	name: "MessageIframe",
	components: {},
	props: {
		origins: { type: Array, required: false, default: () => [] },
		src: { type: String, required: true },
		fullscreen: { type: Boolean, default: false },
		height:{
			type: Number,
			default: 500
		}
	},
	data() {
		return {
			iframe: null,
			width: 800,
		};
	},
	computed: {
		isMobile() {
			return window.innerWidth < this.width;
		},
		minIframeWidth() {
			return window.innerWidth < this.width ? window.innerWidth : this.width;
		},
		minIframeHeight() {
			return 500;
		}
	},
	beforeDestroy() {
		window.removeEventListener("message", this.receiveMessage, false);
	},
	created() {
		window.addEventListener("message", this.receiveMessage, false);
	},
	methods: {
		onIframeLoad() {
			// let iframe = this.$refs.iframe.contentWindow;
			this.$emit("load");
			this.postMessage("welcome", "hello");
			window.addEventListener("keydown", this.passKeyToIframe);
		},
		receiveMessage(event) {
			this.$emit("message", event.data);
		},
		postMessage(action, data) {
			this.$refs.iframe.contentWindow.postMessage(
				{
					action,
					data
				},
				"*"
			);
		},
		postMessageCustom(custom) {
			this.$refs.iframe.contentWindow.postMessage(custom, "*");
		},
		passKeyToIframe(e){
			this.postMessage(JSON.stringify({type:"KeyboardEvent", key:e.key}));
		}
	}
};
</script>

<style scoped>
iframe {
  display: block; /* iframes are inline by default */
  border: none; /* Reset default border */
  width: 100%;
}

.full {
  height: 100vh;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 10000;
}

/*@media screen and (max-width: 769px) {*/
/*	!* STYLES HERE *!*/
/*	.full {*/
/*		position: fixed;*/
/*		top: 0;*/
/*		right: 0;*/
/*		left: 0;*/
/*		height: 100%;*/
/*		width: 100%;*/
/*	}*/
/*}*/
</style>
